import React from "react";

import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";

import Button, { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";
import { ConfirmReceiveSSCCHandles } from "../ConfirmReceiveSSCC";

interface Props {
  show: boolean;
  allCartonsAlreadyReceived?: boolean;
  loading?: boolean;

  confirmReceiveRef: React.RefObject<ConfirmReceiveSSCCHandles>;
}

const ReceiveAllSSCCButton = (props: Props) => {
  const { show, loading, allCartonsAlreadyReceived, confirmReceiveRef } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const onClick = () => confirmReceiveRef.current?.open(true);

  if (!show) return null;

  return (
    <DefaultTooltip
      title={
        allCartonsAlreadyReceived ? translate("allCartonsHaveAlreadyBeenMarkedAsReceived") : ""
      }
    >
      <div>
        <Button
          loading={loading}
          customColor={Color.SECONDARY}
          onClick={onClick}
          disabled={allCartonsAlreadyReceived}
        >
          <FiDownload
            size={GridConstants.defaultRowActionSize}
            color="#FFFFFF"
            className={classes.actionButton}
          />
          <span className={classes.buttonText}>{translate("receiveAllSSCC")}</span>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default ReceiveAllSSCCButton;
